module.exports = __webpack_public_path__ + "static/media/icono-servicios.2d3bdb82.svg";